/**
 * Extracts the breaks from a Booking Corner split such as "09:30-12:30 + 14:00-16:30".
 *
 * Breaks are the gaps between consecutive periods. Booking Corner sometimes models the
 * break as a period of its own, leaving no gap at all (e.g. "09:45-12:00 + 12:00-13:30 + 13:30-15:30"):
 * with three contiguous periods, the middle one is the break.
 */
export const getSplitBreaks = (split?: string | null): string[] => {
    if (!split) return [];

    const periods = split.split('+').map((period) => period.split('-').map((time) => time.trim()));
    if (periods.some((period) => period.length !== 2)) return [];

    const gaps: string[] = [];
    for (let i = 1; i < periods.length; i += 1) {
        const previousEnd = periods[i - 1][1];
        const nextStart = periods[i][0];
        if (previousEnd !== nextStart) gaps.push(`${previousEnd} - ${nextStart}`);
    }
    if (gaps.length > 0) return gaps;

    if (periods.length === 3) return [`${periods[1][0]} - ${periods[1][1]}`];
    return [];
};

export const getSplitBreaksLabelId = (breaks: string[]) => (breaks.length > 1 ? 'booking.durationSplits' : 'booking.durationSplit');
